import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";

export default function Colaboradores() {
    const OPTIONS_FOR_TYPE = [
        { label: "Geral", value: '1' },
        { label: "Turma", value: '2' },
        { label: "Grupo", value: '3' },
        { label: "Qualidade", value: '4' },
    ];

    // 1 - Geral
    // 2 - Turma
    // 3 - Grupo
    // 4 - Qualidade

    const [colaboradores, setColaboradores] = useState([]);
    const [colaborador, setColaborador] = useState({});
    const [turmas, setTurmas] = useState([]);

    const [grupo, setGrupo] = useState('');
    const [grupos, setGrupos] = useState([]);
    const [situacao, setSituacao] = useState('');
    const [turma, setTurma] = useState('');
    const [tipo, setTipo] = useState('1');

    const [display, setDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const toast = useRef(null);

    const handleUpdate = () => {
        const isGeralOuQualidade = tipo === '1' || tipo === '4';

        if (!isGeralOuQualidade && (turma === '' || turma === '0' || turma === 0 || turma === null || turma === undefined)) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, selecione a Turma antes de prosseguir'
            });
            return;
        }

        if (situacao === '' || situacao === null || situacao === undefined) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir'
            });
            return;
        }

        api.post('cadastros/colaboradores/update', {
            "colaborador_id" : colaborador.id,
            "grupo": isGeralOuQualidade ? null : (grupo === '' ? null : grupo),
            "situacao": situacao,
            "turma_id": isGeralOuQualidade ? null : (turma === '' ? null : turma),
            "tipo": tipo
        }).then((response) => {
            hideDialog();
            getData(false);

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            let message;
            if(error.response) {
                message = error.response.data.message;
            } else if(error.request) {
                message = error.request;
            } else {
                message = error.message;
            }
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: message
            });
        });
    }

    const getData = (showLoading = true) => {
        if(showLoading) setLoading(true);
        api.get('cadastros/colaboradores').then((response) => {
            setColaboradores(response.data.colaboradores);
            setGrupos(response.data.grupos);
            setTurmas(response.data.turmas);
            if(showLoading) setLoading(false);
        }).catch((error) => {
            if(showLoading) setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }

    const handleReload = () => {
        setLoading(true);
        api.get('cadastros/colaboradores/reload').then((response) => {
            if(response.status === 200) {
                setColaboradores(response.data.colaboradores);
                setLoading(false);
                toast.current.show({
                    summary: 'Concluído',
                    severity: 'success',
                    detail: response.data.message
                });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error
            });
        });
    }

    const openDialog = (rowData) => {
        setDisplay(true);
        setColaborador(rowData);
        setSituacao(rowData.situacao);
        const isGeralOuQualidade = String(rowData.tipo) === '1' || String(rowData.tipo) === '4';
        setTurma(isGeralOuQualidade ? '' : (rowData.turma_id !== null && rowData.turma_id !== undefined ? rowData.turma_id : ''));
        setGrupo(isGeralOuQualidade ? '' : (rowData.grupo !== null && rowData.grupo !== undefined ? rowData.grupo : ''));
        setTipo(rowData.tipo ? String(rowData.tipo) : '1');
    }

    const hideDialog = () => {
        setDisplay(false);
        setColaborador({});
        setSituacao('');
        setTurma('');
        setGrupo('');
        setTipo('1');
    }

    useEffect(() => {
        getData();
    }, []);

    if(loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog header="Editar" onHide={hideDialog} style={{ minWidth: '45vw' }} visible={display} footer={() => (
                <div>
                    <Button className="p-button-secondary" label="Cancelar" onClick={hideDialog}></Button>
                    <Button className="p-button-success" label="Salvar" onClick={handleUpdate}></Button>
                </div>
            )}>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="matricula">Matrícula</label>
                        <InputText
                            readOnly
                            value={colaborador.matricula || ""}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="nome">Nome</label>
                        <InputText
                            readOnly
                            value={colaborador.nome || ""}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="situacao">Situação</label>
                        <Dropdown options={[
                            { value: 0, label: 'Ativo' },
                            { value: 1, label: 'Afastado' },
                            { value: 2, label: 'Demitido'}
                        ]} value={situacao} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="tipo">Tipo: </label>
                        <Dropdown options={OPTIONS_FOR_TYPE} onChange={e => {
                            setTipo(e.value);
                            if (e.value === '1' || e.value === '4') {
                                setTurma('');
                                setGrupo('');
                            }
                        }} value={tipo} />
                    </div>
                    {tipo !== '1' && tipo !== '4' && (
                        <>
                            <div className="p-field">
                                <label htmlFor="turma">Turma: </label>
                                <Dropdown onChange={e => setTurma(e.value)} options={turmas} value={turma} />
                            </div>
                            <div className="p-field">
                                <label htmlFor="grupo">Grupo: </label>
                                <Dropdown options={grupos} onChange={e => setGrupo(e.value)} value={grupo} />
                            </div>
                        </>
                    )}
                </div>
            </Dialog>

            <Card header={() => (
                <div className="p-d-flex p-flex-row p-jc-between p-ai-start">
                    <h1 className="p-m-2">Colaboradores</h1>
                    <Button className="p-button-success p-m-2" label="Atualizar Colaboradores" onClick={handleReload} />
                </div>
            )} className="p-m-3">
                <DataTable filterDisplay="row" paginator rows={8} responsiveLayout="scroll" value={colaboradores} >
                    <Column header="ID" field="id" />
                    <Column header="Matrícula" filter sortable field="matricula" showFilterMenu={false} style={{ width: "150px" }} />
                    <Column header="Nome" filter sortable field="nome" />
                    <Column header="Turma" filter sortable field="turma" showFilterMenu={false} style={{ width: "150px" }} />
                    <Column header="Grupo" filter sortable field="grupo" showFilterMenu={false} style={{ width: "150px" }} />
                    <Column header="Tipo" filter sortable  field="tipof" showFilterMenu={false} style={{ width: "150px" }} />
                    <Column header="Situação" sortable field="situacao" body={(rowData) => {
                        if(rowData.situacao === "0") {
                            return 'Ativo';
                        } else if(rowData.situacao === "1") {
                            return 'Afastado';
                        } else {
                            return 'Demitido';
                        }
                    }} />
                    <Column header="Ações" body={(rowData) => (
                        <Button icon="pi pi-pencil" onClick={() => openDialog(rowData)} />
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}